import { bool, node } from 'prop-types';

import { useBrandingConfig } from '../../hooks/branding';
import AuthLogo from '../logo';

import AuthFooter from './footer';
import './index.scss';

function AuthLayout({ children, withFooter }) {
  const { loginExtraContent } = useBrandingConfig();
  return (
    <div className="AuthLayout alk-flex">
      <AuthLogo />
      <div className="AuthLayout__body">{children}</div>
      {loginExtraContent && (
        <div className="AuthLayout__extraContent">{loginExtraContent}</div>
      )}
      {withFooter && <AuthFooter />}
    </div>
  );
}

AuthLayout.propTypes = {
  children: node,
  withFooter: bool,
};

export default AuthLayout;
